// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5299":"3b53517f","6732":"3b53517f","6890":"3b53517f"}[chunkId] + ".chunk.css";
};